<template>
  <div>
    <div class="flex items-center space-x-4">
      <router-link :to="{ name: 'expensesIndex' }" class="system-button">
        <arrow-icon class="w-4 rotate-90"></arrow-icon>
      </router-link>
      <h2>{{ isEditing ? "Editar" : "Crear" }} Egreso</h2>
    </div>

    <div v-if="!loading" class="card mt-2">
      <form v-if="categories" @submit.prevent="save">
        <section-header title="Datos del Egreso" />

        <div class="form-grid">
          <div class="form-field">
            <label for="expense_category_id">Concepto</label>
            <custom-select
              v-model="form.expense_category_id"
              id="expense_category_id"
              :options="getCategoryOptions()"
            />
            <validation-errors :errors="errorFor('expense_category_id')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="amount">Monto</label>
            <input id="amount" type="number" step="any" v-model="form.amount" />
            <validation-errors :errors="errorFor('amount')"></validation-errors>
          </div>

          <div class="form-field">
            <label for="date_time">Fecha (dejar vacía si es actual)</label>
            <input
              id="date_time"
              type="datetime-local"
              v-model="form.date_time"
            />
            <validation-errors
              :errors="errorFor('date_time')"
            ></validation-errors>
          </div>
        </div>

        <primary-button type="submit" class="mt-6 mx-0" :loading="loadingForm"
          >{{ isEditing ? "Guardar" : "Crear" }}
        </primary-button>
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
export default {
  name: "Expense Form",

  data() {
    return {
      form: {
        expense_category_id: null,
        amount: null,
        date_time: null,
      },
      loading: false,
      loadingForm: false,
      isEditing: false,
      categories: null
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "accounting");

    this.loadCategories();

    if (this.$route.params.id) {
      this.isEditing = true;
      this.loadExpense();
    }
  },

  mixins: [validationErrors],

  methods: {
    async loadCategories() {
      this.loading = true;

      try {
        this.categories = await api.resources.getExpenseCategories();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    async loadExpense() {
      this.loading = true;

      try {
        let expense = await api.expenses.getById(this.$route.params.id);
        expense.date_time = expense.date_time.replace(" ", "T").slice(0, 16);
        this.form = await JSON.parse(JSON.stringify(expense));
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    getCategoryOptions() {
      if (!this.categories) {
        return [];
      }

      const options = [{ value: null, label: "Seleccionar", disabled: false }];

      this.categories.forEach((category) => {
        options.push({
          value: category.id,
          label: category.name,
        });
      });

      return options;
    },

    save() {
      this.form.branch_id = this.$route.params.branchId;
      
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      if (!this.isEditing) {
        this.createExpense();
      } else {
        this.updateExpense();
      }
    },

    validateForm() {
      this.errors = {};

      if (!this.form.expense_category_id) {
        this.errors["expense_category_id"] = ["Campo requerido"];
      }

      if (!this.form.amount) {
        this.errors["amount"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async createExpense() {
      this.loadingForm = true;

      try {
        const response = await api.expenses.create(this.form);
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "expensesIndex" });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },

    async updateExpense() {
      this.loadingForm = true;

      try {
        const response = await api.expenses.update(
          this.$route.params.id,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "expensesIndex" });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },
};
</script>